const normalizeBaseUrl = (value) => String(value || 'https://api.apiz.ai').replace(/\/$/, '');

export const API_ROOT = normalizeBaseUrl(process.env.CANVAS_API_BASE);
export const API_BASE = `${API_ROOT}/api`;
export const API_BASE_V2 = `${API_BASE}/v2`;
export const CANVAS_CLIENT_SOURCE = 'juchacha_canvas';

export const ENDPOINTS = {
  JIMENG_TASK_CREATE: `${API_BASE}/jimeng/task/create`,
  MINIMAX_VOICES_UPDATE: `${API_BASE_V2}/minimax/voices/update`
};

export const getCanvasPublicUrl = () => {
  const configured = String(process.env.CANVAS_PUBLIC_URL || '').replace(/\/$/, '');
  if (configured) return configured;
  if (typeof window !== 'undefined') return window.location.origin;
  return '';
};

export default {
  API_ROOT,
  API_BASE,
  API_BASE_V2,
  CANVAS_CLIENT_SOURCE,
  ENDPOINTS
};
